var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrachage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.298,
    height: 85.298,
    viewBox: "0 0 85.298 85.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2891",
    "data-name": "Groupe 2891",
    transform: "translate(-114.086)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 42.649,
    cy: 42.649,
    r: 42.649,
    transform: "translate(114.086)",
    fill: "#d39684"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2464",
    "data-name": "Groupe 2464",
    transform: "translate(135.685 13.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_16",
    "data-name": "Ligne 16",
    d: "M0,30.656a1,1,0,0,1-.487-.127,1,1,0,0,1-.385-1.361L15.71-.488a1,1,0,0,1,1.361-.385A1,1,0,0,1,17.456.488L.873,30.144A1,1,0,0,1,0,30.656Z",
    transform: "translate(11.788 10.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_17",
    "data-name": "Ligne 17",
    d: "M0,30.656a1,1,0,0,1-.487-.127,1,1,0,0,1-.385-1.361L15.71-.488a1,1,0,0,1,1.361-.385A1,1,0,0,1,17.456.488L.873,30.144A1,1,0,0,1,0,30.656Z",
    transform: "translate(15.888 12.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2463",
    "data-name": "Groupe 2463",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2465",
    "data-name": "Groupe 2465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_833",
    "data-name": "Trac\\xE9 833",
    d: "M16.373,447.5a23.029,23.029,0,0,1-3.895-.331,1,1,0,0,1-.574-.321,22.451,22.451,0,0,1-3.641-5.668,14.3,14.3,0,0,1-1.2-4.648,10.429,10.429,0,0,1,.941-5.217,119.663,119.663,0,0,1,6.6-11.443,1,1,0,0,1,1.276-.257l6.743,3.771a1,1,0,1,1-.976,1.746l-5.954-3.329c-1.516,2.314-4.938,8.362-5.874,10.36-1.13,2.419-1.037,5.185.278,8.223a20.3,20.3,0,0,0,3.073,4.871,20.26,20.26,0,0,0,5.761.069c3.276-.47,5.681-1.839,7.149-4.07,1.208-1.83,4.571-7.916,5.751-10.429l-5.787-3.236a1,1,0,1,1,.976-1.746l6.576,3.677a1,1,0,0,1,.449,1.221,118.326,118.326,0,0,1-6.3,11.612,10.42,10.42,0,0,1-3.949,3.534,14.287,14.287,0,0,1-4.586,1.415A20.116,20.116,0,0,1,16.373,447.5Z",
    transform: "translate(-8.038 -388.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_18",
    "data-name": "Ligne 18",
    d: "M3.575,3a1,1,0,0,1-.487-.127l-3.576-2A1,1,0,0,1-.873-.488,1,1,0,0,1,.488-.873l3.576,2A1,1,0,0,1,3.575,3Z",
    transform: "translate(17.025 31.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_834",
    "data-name": "Trac\\xE9 834",
    d: "M357,22.037a1,1,0,0,1-.359-1.934l7.262-2.787a1.579,1.579,0,0,0,.206-2.853l-9.331-5.218a1.579,1.579,0,0,0-2.323,1.669l1.428,7.646a1,1,0,1,1-1.966.367l-1.428-7.646A3.579,3.579,0,0,1,355.757,7.5l9.331,5.218a3.579,3.579,0,0,1-.466,6.466l-7.262,2.787A1,1,0,0,1,357,22.037Zm-.253-3.724a1.641,1.641,0,0,1-1.516-1.021l-1.943-4.833a1.629,1.629,0,0,1,2.307-2.03l7.078,3.958a1.629,1.629,0,0,1-.522,3.029l-5.135.875A1.606,1.606,0,0,1,356.75,18.314Zm-1.212-5.626,1.44,3.581,3.805-.648Z",
    transform: "translate(-324.532 -8.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_19",
    "data-name": "Ligne 19",
    d: "M3.737,3.09a1,1,0,0,1-.487-.127L-.488.873A1,1,0,0,1-.873-.488,1,1,0,0,1,.488-.873l3.738,2.09A1,1,0,0,1,3.737,3.09Z",
    transform: "translate(26.094 14.838)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrachage);
export default __webpack_public_path__ + "static/media/arrachage.f2d71ef134f954d582afca82f8052c02.svg";
export { ForwardRef as ReactComponent };